<template>
  <div class="liveinfo">
    <el-card>
      <el-form ref="searchForm" :model="searchForm" :label-width="typeFormLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="4">
            <el-select v-model="searchForm.scene" placeholder="请选择直播分类">
              <el-option label="普通直播" :value="1"></el-option>
              <el-option label="云课程" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入直播名称"
              auto-complete="off"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="9" style="float: right">
            <div style="float: right" class="flex-starts">
              <el-button-group style="float: right">
                <el-button
                  type="primary"
                  @click="(page.pageNumber = 1), pageList()"
                  icon="el-icon-search"
                  v-auth="'/liveList/pageList'"
                  >查询</el-button
                >
                <el-button type="primary" @click="goAddLiveInfo" icon="el-icon-plus"  v-auth="'/liveList/goAddLiveInfo'"
                  >添加直播</el-button
                >
                <!-- <el-button type="danger" @click="batchDeleteVideoCourse" icon="el-icon-minus">批量删除</el-button> -->
              </el-button-group>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card">
      <el-card class="companyInfoDiv" :key="companyInfo.name">
        <div class="title">{{ companyInfo.name }}</div>
        <div class="">观看时长</div>
        <div class="playTime">{{ companyInfo.playDurationSum || 0 }}分钟</div>
      </el-card>

      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="selectionChange"
        v-loading="videoCourseLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="name" label="直播名称">
          <template slot-scope="scope">
            <div class="flex-starts">
              <img class="table_image" height="50" width="70" :src="scope.row.coverUrl" />
              <div class="table_text">{{ scope.row.name }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="scene" label="直播分类">
          <template slot-scope="scope">
            <span v-if="scope.row.scene == 1">普通直播</span>
            <span v-if="scope.row.scene == 2">云课堂</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="beginTime"
          label="开始时间"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="endTime"
          label="结算时间"
        ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="liveState" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.polyvState == 0">未开始</span>
            <span v-if="scope.row.polyvState == 1" style="color: #24d2b5">直播中</span>
            <span v-if="scope.row.polyvState == -1" style="color: #a2aabc">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="pcPlayDuration" label="pc时长">
          <template slot-scope="scope">
            {{ scope.row.pcPlayDuration || 0 }}分钟
          </template>
        </el-table-column>
        <el-table-column prop="mobilePlayDuration" label="移动端时长">
          <template slot-scope="scope">
            {{ scope.row.mobilePlayDuration || 0 }}分钟
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="el-icon-edit icon-style"
                title="编辑"
                @click="getChannel(scope.row.id)"
                v-auth="'/liveList/getChannel'"
              ></i>
              <span class="mainColor" @click="toLiveInfoInformation(scope.row)"
                    v-auth="'/liveList/toLiveInfoInformation'"
                >详情</span
              >
              <span class="mainColor" @click="shareVisibleTrue(scope.row)"
                    v-auth="'/liveList/shareVisibleTrue'"
              >分享</span>
              <span class="mainColor" @click="liveInfoVisibleTrue(scope.row)"
                    v-auth="'/liveList/liveInfoVisibleTrue'"
                >去直播</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="直播链接"
      :visible.sync="liveInfoVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form :model="liveInfoForm" :label-width="liveInfoFormLabelWidth">
        <el-form-item label="网页开播链接：">
          <el-row :gutter="20">
            <el-col :span="18">
              <el-input v-model="liveInfoForm.link1"></el-input>
            </el-col>
            <el-col :span="5">
              <el-button type="text" @click="openUrl(liveInfoForm.link1)">打开</el-button>
              <el-button
                type="text"
                v-clipboard:copy="liveInfoForm.link1"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >复制</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="启动客户端链接：">
          <el-row :gutter="20">
            <el-col :span="18">
              <el-input v-model="liveInfoForm.link2"></el-input>
            </el-col>
            <el-col :span="5">
              <el-button type="text" @click="openUrl(liveInfoForm.link2)">打开</el-button>
              <el-button
                type="text"
                v-clipboard:copy="liveInfoForm.link2"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >复制</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="">
          <div class="liveInfo_teacher">
            <div>频道号：{{ liveInfoForm.channelNumber }}</div>
            <div style="margin-left: 50px">
              直播密码：{{ liveInfoForm.channelPassword }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="分享"
      :visible.sync="shareVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-row :gutter="20" style="padding-bottom: 20px">
        <el-col :span="7">
          <img class="liveList_qrCode" width="124" height="124" :src="qrCodeUrl" alt />
          <!-- <div id="qrcode" class="liveList_qrCode"></div> -->
        </el-col>
        <el-col :span="17">
          <el-input v-model="copyUrl" class="share_input">
            <template slot="append" style="background: #409eff">
              <el-button
                v-clipboard:copy="copyUrl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >复制</el-button
              >
            </template>
          </el-input>
          <div style="margin-top: 20px">
            <el-button type="text" @click="savePic">下载二维码</el-button>
            <!-- <el-button type="text" @click="shareSettingVisible=true">分享修改设置</el-button> -->
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      title="分享设置"
      :visible.sync="shareSettingVisible"
      :close-on-click-modal="false"
      append-to-body
      width="60%"
    >
      <el-row>
        <el-col :span="8">
          <img width="140" height="140" src="../../../static/image/share.png" alt />
        </el-col>
        <el-col :span="16">
          <el-form
            ref="shareAddForm"
            :model="shareAddForm"
            :label-width="formLabelWidth"
            :rules="shareAddFormRules"
          >
            <el-form-item label="分享标题" prop="name">
              <el-input v-model="shareAddFormRules.name"></el-input>
            </el-form-item>
            <el-form-item label="分享描述" prop="name">
              <el-input type="textarea" v-model="shareAddFormRules.name"></el-input>
            </el-form-item>
            <el-form-item label="分享图片" prop="name">
              <div
                v-if="image == null"
                class="upload_type el-icon-plus"
                @click="photoMaterialVisible = true"
              ></div>
              <div v-else @click="photoMaterialVisible = true">
                <img class="upload_type_img" width="100" height="100" :src="image" />
              </div>
              <div class="small_text">
                建议：上传尺寸为1:1的PNG、JPG、GPEG、GIF、BMP图片，大小不超过1M
              </div>
            </el-form-item>
          </el-form>
          <div style="margin-left: 90px">
            <!-- <el-button @click="goBack">取消</el-button> -->
            <el-button type="primary">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      title="添加"
      :visible.sync="photoMaterialVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <photoMaterial @photoChange="photoChange"></photoMaterial>
    </el-dialog>

    <el-dialog
      title="资料"
      :visible.sync="bindMaterialsVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <div style="margin-botton: 20px; height: 40px">
        <el-upload
          style="float: left"
          class="upload-demo"
          :action="materialsFileAction"
          :on-success="materialsHandleSuccess"
          :headers="reqData"
          :file-list="materialsFileList"
        >
          <el-button type="primary" :loading="uploadLoading" @click="uploadLoading = true"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <div style="width: 100%" class="draggable-tableaaa">
        <div style class="draggable-table">
          <div class="answer bor" style="width: 10%">排序</div>
          <div class="answer bor" style="width: 70%">附件</div>
          <div class="delete bor" style="width: 20%">操作</div>
        </div>
        <draggable
          v-if="materialsImportList.length"
          v-model="materialsImportList"
          @update="datadragEnd"
          :options="{ animation: 500 }"
        >
          <div
            v-for="(element, index) in materialsImportList"
            :key="index"
            class="drag-item"
          >
            <div class="draggable-table">
              <div style="width: 10%" class="answer">{{ index + 1 }}</div>
              <el-tooltip
                :open-delay="500"
                class="item"
                effect="dark"
                :content="element.name"
              >
                <div style="width: 70%" class="answer">{{ element.name || "null" }}</div>
              </el-tooltip>
              <div style="width: 20%" class="delete">
                <i class="videoCourse-icon el-icon-download" @click="down(element)"></i>
                <i class="videoCourse-icon el-icon-delete" @click="delect(element)"></i>
              </div>
            </div>
          </div>
        </draggable>
        <div
          v-else
          style="
            text-align: center;
            line-height: 60px;
            color: #909399;
            border-bottom: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
          "
        >
          暂无数据
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import photoMaterial from "../common/photoMaterial.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  components: { draggable, photoMaterial, QRCode },
  data() {
    return {
      liveInfoVisible: false,
      shareVisible: false,
      shareSettingVisible: false,
      photoMaterialVisible: false,
      copyUrl: null,
      qrCodeUrl: null,
      materialsFileAction: `${process.env.POI_URL}/videoInfo/upload`,
      materialsFileList: [],
      teacherList: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      bindVisible: false,
      bindMaterialsVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      typeId: [],
      tencentVideoTypeId: "",
      courseIds: [],
      liveInfoForm: {
        link1: null,
        link2: null,
        channelNumber: null,
        channelPassword: null,
      },
      searchForm: {
        scene: null,
        name: null,
      },
      typeTreeList: [],
      typeTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      typeId: [],
      addForm: {
        courseId: "",
        name: "",
        remark: "",
        enabled: "1",
      },
      shareAddForm: {},
      shareAddFormRules: {},
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入课程id(第三层) 财务类-初级-经济法",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字",
          },
        ],
      },
      editForm: {
        courseId: "",
        name: "",
        type: "",
        remark: "",
      },
      editFormRules: {
        type: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        courseId: [
          {
            required: true,
            message: "请输入课程id(第三层) 财务类-初级-经济法",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字",
          },
        ],
      },
      importForm: {},
      materialsImportList: [],
      typeFormLabelWidth: "100px",
      liveInfoFormLabelWidth: "110px",
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/videoCourse/upload`,
      fileList: [],
      loading: false,
      uploadLoading: false,
      subjectTreeList: [], //科目
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      temple: [],
      videoCourseLoading: "true",
      videoCourseId: "",
      typeName: "",
      comMonid: "",
      MaterialsVideoCourseId: "",
      image: null,
      companyInfo: {
        name: "",
        playDurationSum: "",
      },
    };
  },
  methods: {
    getAgentInfo() {
      this.api.getAgentInfoById(this.loginData.agentId).then((result) => {
        this.companyInfo = result.data;
      });
    },
    /*-------------------------------------------上传图片--------------------------------------- */
    photoChange(val) {
      this.addForm.cover = val[0].id;
      this.image = val[0].url;
      this.photoMaterialVisible = false;
    },

    /*-------------------------------------------去直播--------------------------------------- */
    openUrl(url) {
      console.log("111", url);
      window.open(url);
    },

    /*-------------------------------------------直播详情--------------------------------------- */
    toLiveInfoInformation(row) {
      this.$router.push({
        path: "/liveInfoInformation",
        query: { id: row.id, channelId: row.channelNumber },
      });
    },

    /*-------------------------------------------分享设置--------------------------------------- */

    shareVisibleTrue(row) {
      let agentId = JSON.parse(localStorage.getItem("user")).agentId;
      console.log(process.env.NODE_ENV, "NODE_ENVNODE_ENV");
      ("production");
      if (process.env.NODE_ENV == "production")
        this.copyUrl = agentId
          ? "http://" + agentId + ".h5.68wx.com/pages/videoInfo/index?id=" + row.id
          : "";
      else
        this.copyUrl = agentId
          ? "http://" + agentId + ".test.h5.68wx.com/pages/videoInfo/index?id=" + row.id
          : "";
      this.qrCodeUrl = row.qrCodeUrl;
      this.shareVisible = true;
      // this.$nextTick(function () {
      //   document.getElementById("qrcode").innerHTML = "";
      //   this.liveQrcode(this.copyUrl);
      // });
    },

    liveQrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 124,
        height: 124, // 高度
        text: url, // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },

    savePic() {
      let myCanvas = document.getElementById("qrcode").getElementsByTagName("canvas");
      let a = document.createElement("a");
      a.href = myCanvas[0].toDataURL("image/png");
      a.download = "直播分享二维码";
      a.click();
      this.$message.success("下载成功!");
    },

    liveInfoVisibleTrue(row) {
      this.liveInfoForm.channelNumber = row.channelNumber;
      this.liveInfoForm.channelPassword = row.channelPassword;
      this.liveInfoForm.link1 =
        "https://live.polyv.net/web-start/?channelId=" + row.channelNumber;
      this.liveInfoForm.link2 =
        "https://live.polyv.net/start-client.html?channelId=" + row.channelNumber;
      this.liveInfoVisible = true;
    },
    onCopy(e) {
      console.log("11", e);
      this.$message.success("复制成功！");
      // this.api.polyvChannel.channelMenuList().then((result) => {});
    },
    onError(e) {
      console.log("22", e);
      this.$message.error("复制失败！");
    },
    getChannelIdV2(val) {
      this.api.polyvChannel
        .getChannelIdV2({ channelNumber: 1882896 })
        .then((result) => {});
    },

    /*-------------------------------------------添加/修改直播--------------------------------------- */
    goAddLiveInfo() {
      this.$router.push({ path: "/addLiveInfo" });
    },
    getChannel(id) {
      this.$router.push({ path: "/editLiveInfo", query: { id: id } });
    },

    /*-------------------------------------------获取数据--------------------------------------- */
    getTeacherList() {
      this.api.agentUserInfo.getAgentTeacherList().then((result) => {
        this.teacherList = result.data;
      });
    },
    opConmon(row) {
      this.bindVisible = true;
      this.comMonid = row.id;
      this.typeName = row.type;
    },
    opMaterials(id) {
      this.MaterialsVideoCourseId = id;
      this.materialsImportList = [];
      this.api.videoMaterials
        .getVideoMaterials({ videoCourseId: this.MaterialsVideoCourseId })
        .then((result) => {
          if (result.success) {
            this.materialsImportList = result.data.attachmentList;
          }
        });
      this.bindMaterialsVisible = true;
      // this.typeName = row.type;
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTencentVideoTypeTree(row) {
      this.videoCourseId = row;
      this.api.tencentVideoInfo.getTencentVideoTypeTree().then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  delete itemss.children;
                }
              } else {
                // delete items.children;
              }
            }
          } else {
            // delete item.children;
          }
        }
        this.typeTreeList = result.data;
      });
    },
    typeSearchChange() {
      if (this.typeId.length > 0) {
        this.tencentVideoTypeId = this.typeId[2];
      } else {
        this.tencentVideoTypeId = "";
      }
      console.log("this.searchForm.typeId", this.searchForm.typeId);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    startTimeChange() {
      var date = new Date(this.addForm.startTime);
      date.setFullYear(date.getFullYear() + 1);
      date.setDate(date.getDate() - 1);
      this.addForm.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    startTimeChangeEdit() {
      var date = new Date(this.editForm.startTime);
      date.setFullYear(date.getFullYear() + 1);
      date.setDate(date.getDate() - 1);
      this.editForm.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getVideoCourse() {
      this.api.videoCourse
        .getVideoCourse({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          this.editForm.enabled = String(this.editForm.enabled);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.polyvChannel
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.videoCourseLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addVideoCourse() {
      if (this.blockAddVideoCourse) {
        return false;
      }
      this.blockAddVideoCourse = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.courseId = String(this.addForm.courseId[2]);
          this.api.videoCourse
            .addVideoCourse(this.addForm)
            .then((result) => {
              this.addFormVisible = false;
              if (result.success) {
                this.addFormVisible = false;
                this.$message.success(result.message);
                this.blockAddVideoCourse = false;
              } else {
                this.$message.error(result.message);
                this.blockAddVideoCourse = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    subjectChangeTop() {
      this.courseIds.forEach((e) => {
        this.searchForm.courseIds.push(e[2]);
      });
      // this.searchForm.courseIds = this.courseIds;
      // console.log("11",this.searchForm.courseIds)
    },
    subjectChange() {
      this.editForm.courseId = String(this.editForm.courseId[2]);
    },
    updateSwitching(row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled,
      };
      this.api.videoCourse.updateVideoCourseEnable(obj).then((result) => {
        if (result.success) {
          this.pageList();
          this.$message.success(result.message);
        } else {
          this.pageList();
          this.$message.error(result.message);
        }
      });
    },

    datadragEnd(evt) {
      let arr = [];
      this.materialsImportList.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      this.api.videoMaterials
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
      // console.log(this.colors);
    },
    updateVideoCourse() {
      if (this.blockUpdateVideoCourse) {
        return false;
      }
      this.blockUpdateVideoCourse = true;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.videoCourse
            .updateVideoCourse(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.blockUpdateVideoCourse = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
                this.blockUpdateVideoCourse = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteVideoCourse(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.videoCourse
            .deleteVideoCourse([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    bindTencentVideoType() {
      let obj = {
        tencentVideoTypeId: this.tencentVideoTypeId,
        videoCourseId: this.videoCourseId,
      };
      this.api.videoCourse.bindTencentVideoType(obj).then((result) => {
        if (result.success) {
          this.bindVisible = false;
          this.tencentVideoTypeId = "";
          this.videoCourseId = "";
          this.$message.success(result.message);
          this.pageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    batchDeleteVideoCourse() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.videoCourse
            .deleteVideoCourse(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.courseIds = [];
      this.searchForm.type = "";
      this.searchForm.name = "";
      this.courseIds = [];
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    materialsHandleSuccess(response, file, fileList, $event) {
      this.uploadLoading = true;
      // console.log("response.data",response.data)
      // this.materialsImportList.push(response.data);
      let obj = {
        name: file.raw.name,
        size: file.raw.size,
        type: file.raw.type,
        url: response.data.split("?")[0],
      };
      let obj2 = {
        videoCourseId: this.MaterialsVideoCourseId,
        attachment: obj,
      };
      this.api.videoMaterials.addVideoMaterials(obj2).then((result) => {
        if (result.success) {
          this.uploadLoading = false;
          this.materialsImportList.push(obj);
          this.opMaterials(this.MaterialsVideoCourseId);
        }
      });
      setTimeout(() => {
        this.uploadLoading = false;
      }, 3000);

      // for (let i in this.addForm.attachments) {
      //   this.addForm.attachments[i].index = i;
      //   this.addForm.attachments[i].url = this.addForm.attachments[i].url.split(
      //     "?"
      //   )[0];
      // }
      // if (this.state == 2) {
      //   obj.objectId = this.addForm.id;
      //   this.api.attachment.addAttachment(obj).then(result => {});
      // }
    },
    down(item) {
      const url = item.url;
      window.open(url);
    },
    delect(item) {
      this.$confirm("系统将删除该文件，是否确认删除？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          let obj = {
            id: item.id,
          };
          this.api.attachment.deleteAttachment([obj]).then((result) => {});
          this.materialsImportList.splice(item.index, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportExcel() {
      this.loading = true;
      this.api.videoCourse
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData() {
      this.api.videoCourse
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
  watch: {
    bindVisible: function (newVal) {
      if (!newVal) {
        this.pageList();
      } else {
        this.pageList();
      }
    },
    bindMaterialsVisible: function (newVal) {
      if (!newVal) {
        this.pageList();
        this.materialsImportList = [];
      } else {
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    "editForm.type": function () {
      if (this.editForm.type == "直播") {
        this.editForm.startTime = this.editForm.startTime;
        this.editForm.endTime = this.editForm.endTime;
      } else {
        this.editForm.startTime = "";
        this.editForm.endTime = "";
      }
    },

    "addForm.type": function () {
      if (this.addForm.type == "直播") {
        this.addForm.startTime = this.addForm.startTime;
        this.addForm.endTime = this.addForm.endTime;
      } else {
        this.addForm.startTime = "";
        this.addForm.endTime = "";
      }
    },

    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getVideoCourse();
      }
    },
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
    this.getTeacherList();
    this.getAgentInfo();
  },
};
</script>
<style scoped>
.companyInfoDiv {
  width: 300px;
  margin: 20px 0;
}
.companyInfoDiv .playTime {
  font-size: 30px;
  font-weight: 500;
  margin-top: 10px;
}
.companyInfoDiv .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.videoCourse-icon {
  margin: 0px 10px;
  font-size: 13px;
  color: #409eff;
}
.table_image {
  border-radius: 6px;
}
.table_text {
  margin-left: 10px;
}
.upload_type {
  width: 140px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  line-height: 140px;
  text-align: center;
  line-height: 100px;
  font-size: 20px;
  border-radius: 6px;
  cursor: pointer;
}
.upload_type_img {
  width: 140px;
  height: 100px;
  line-height: 140px;
  text-align: center;
  line-height: 100px;
  font-size: 20px;
  border-radius: 6px;
  cursor: pointer;
}
.upload_type:hover {
  color: #409eff;
  border-color: #409eff;
}
.liveInfo_teacher {
  display: flex;
  margin-left: 10px;
}
.liveList_qrCode {
  width: 124px;
  height: 124px;
  border: 1px solid #ccc;
  padding: 5px;
}
</style>
<style lang="less">
.liveinfo {
  .el-upload-list {
    display: none !important;
  }
}

.share_input {
  .el-input-group__append {
    background: #409eff;
    color: #fff;
    cursor: pointer;
  }
}
</style>

<style lang="less" scoped>
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }
  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }
    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        display: none !important;
      }
      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;
        img {
          display: none !important;
        }
      }
    }
    .title {
      width: 60%;
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .state {
        padding: 0;
        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      white-space: nowrap;
    }
    .answer {
      width: 22%;
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #eee;
      text-align: center;
      border-right: 1px solid #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/liveInfo/liveList.vue